/**
 * ClemtexAppearsIn — shopping entry point.
 *
 * Adds an "Appears In" carousel to the product page (full PDP only, not the
 * quick view): the diagram / parts-list pages the part is on, with their
 * thumbnails, styled like the native "Customers who bought this item also
 * bought" carousel directly below it.
 *
 * Zero page-load cost beyond the slider: the carousel HTML is pre-built in the
 * item field custitem_appears_in_carousel (Web Categories / MA2C suitelet) and
 * arrives with the item data the page already fetches. Nothing is looked up.
 */
define('Clemtex.AppearsIn', [
    'Clemtex.AppearsIn.View'
], function (AppearsInView) {
    'use strict';

    return {
        mountToApp: function mountToApp(container) {
            try {
                var pdp = container.getComponent('PDP');
                if (!pdp || !pdp.addChildViews) { return; }

                // "Related.Items" is the placeholder just above the correlated-items
                // carousel in product_details_full.tpl; the native view in it is
                // usually empty on this site. Index 10 keeps us after it when it isn't.
                pdp.addChildViews(pdp.PDP_FULL_VIEW, {
                    'Related.Items': {
                        'Clemtex.AppearsIn.View': {
                            childViewIndex: 10,
                            childViewConstructor: function () {
                                return new AppearsInView({
                                    carouselHtml: AppearsInView.carouselHtmlFrom(pdp.getItemInfo())
                                });
                            }
                        }
                    }
                });
            } catch (e) {
                if (window.console) { window.console.error('ClemtexAppearsIn mount failed', e); }
            }
        }
    };
});
